import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Layout({ children, title }) {
  const navigate = useNavigate();
  const location = useLocation();
  const admin = JSON.parse(localStorage.getItem('admin') || '{}');

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('admin');
    navigate('/');
  };

  const menu = [
    { path:'/dashboard', label:'Dashboard', icon:'D' },
    { path:'/admins', label:'Administradores', icon:'A' },
    { path:'/partidos', label:'Partidos', icon:'P' },
    { path:'/usuarios', label:'Usuarios', icon:'U' },
    { path:'/logs', label:'Auditoria', icon:'L' },
  ];

  return (
    <div style={s.wrap}>
      <aside style={s.side}>
        <div style={s.logo}>
          <div style={s.logoTitle}>Painel de Controle</div>
          <div style={s.logoDom}>painel.asscamp.app</div>
        </div>
        <nav style={s.nav}>
          {menu.map(m => (
            <div key={m.path} onClick={() => navigate(m.path)}
              style={{...s.item, ...(location.pathname===m.path ? s.active : {})}}>
              {m.label}
            </div>
          ))}
        </nav>
        <div style={s.user}>
          <div style={s.avatar}>{admin.nome ? admin.nome.charAt(0) : 'A'}</div>
          <div style={s.userInfo}>
            <div style={s.userName}>{admin.nome || 'Admin'}</div>
            <div style={s.userRole}>Administrador</div>
          </div>
          <button onClick={logout} style={s.logout}>Sair</button>
        </div>
      </aside>
      <main style={s.main}>
        <div style={s.topbar}>
          <h2 style={s.pageTitle}>{title}</h2>
        </div>
        <div style={s.content}>{children}</div>
      </main>
    </div>
  );
}

const s = {
  wrap:{display:'flex',minHeight:'100vh',background:'#f0f2f5',fontFamily:'sans-serif'},
  side:{width:220,background:'#1a1a2e',display:'flex',flexDirection:'column',padding:'24px 0'},
  logo:{padding:'0 20px 24px',borderBottom:'1px solid #2a2a4a'},
  logoTitle:{fontSize:13,fontWeight:600,color:'#fff'},
  logoDom:{fontSize:10,color:'#534AB7',marginTop:2},
  nav:{flex:1,padding:'16px 0'},
  item:{padding:'10px 20px',color:'#aaa',cursor:'pointer',fontSize:14},
  active:{background:'#534AB7',color:'#fff'},
  user:{display:'flex',alignItems:'center',gap:8,padding:'16px 20px',borderTop:'1px solid #2a2a4a'},
  avatar:{width:30,height:30,borderRadius:'50%',background:'#534AB7',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:13},
  userInfo:{flex:1},
  userName:{fontSize:12,color:'#fff',fontWeight:500},
  userRole:{fontSize:10,color:'#888'},
  logout:{background:'none',border:'1px solid #444',color:'#888',cursor:'pointer',fontSize:11,borderRadius:4,padding:'3px 8px'},
  main:{flex:1,display:'flex',flexDirection:'column'},
  topbar:{background:'#fff',padding:'16px 28px',borderBottom:'1px solid #eee'},
  pageTitle:{margin:0,fontSize:18,fontWeight:600,color:'#1a1a2e'},
  content:{padding:28,flex:1},
};
